import { Component, Input } from '@angular/core';
import { CupcakePopoverOptions } from '@ipreo/cupcake-components';

@Component({
  selector: 'muni-gameday-comment',
  templateUrl: './comment.template.html',
  styleUrls: ['./comment.styles.scss'],
  standalone: false
})
export class CommentComponent {
  private popoverOptions = new CupcakePopoverOptions({
    trigger: 'click',
    text: '',
    position: 'right'
  });

  @Input()
  public set text(value: string) {
    this.popoverOptions = new CupcakePopoverOptions({
      trigger: 'click',
      text: `${value || ''}`,
      position: 'right'
    });
  }

  public get text(): string {
    return (this.popoverOptions?.text as string) || '';
  }

  public get popover(): CupcakePopoverOptions {
    return this.popoverOptions;
  }
}
